import Cookies from 'js-cookie'
import { NEXT_SESSION_CLEARED } from './phone-lifecycle'
import { getToken, setToken } from '@/global.config'
import { createGatewayClient } from './gateway.mjs'
export function clearNextSession() {
  window.dispatchEvent(new Event(NEXT_SESSION_CLEARED))
  for (const key of ['access_token', 'password', 'vue_admin_template_token', 'username']) Cookies.remove(key, { path: '/' })
  localStorage.removeItem('business_web_token')
}
export const gateway = createGatewayClient({ fetcher: (...args: Parameters<typeof fetch>) => fetch(...args), getToken, setToken, clearToken: clearNextSession })
